import HubSession from '@/server-events/HubSession';
import { BuyerLandingPageData, ChangeRequestProgressInfo, BuyerCommentThreadOverview } from '@/types';
import { getCMConnectionManager } from './connections';

type LandingPageReceiveHandler = (landingPage: BuyerLandingPageData) => void;
type CommentThreadOverviewReceiveHandler = (commentThreadsOverview: BuyerCommentThreadOverview[]) => void;
type ChangeRequestInfoReceiveHandler = (changeRequests: ChangeRequestProgressInfo) => void;

type EventHandler = LandingPageReceiveHandler | CommentThreadOverviewReceiveHandler | ChangeRequestInfoReceiveHandler;
export class BuyerSession extends HubSession {
    private _profileId: number;
    private _residentialUnitId: number;

    constructor(profileId: number, residentialUnitId: number) {
        super(getCMConnectionManager());
        this._profileId = profileId;
        this._residentialUnitId = residentialUnitId;

        this.join();
    }

    onReconnect() {
        this.join();
    }

    join() {
        this.connection.invoke('JoinBuyer', this._profileId, this._residentialUnitId);
    }

    protected addHandler(method: 'ReceiveCommentThreadsOverview', handler: CommentThreadOverviewReceiveHandler): void;
    protected addHandler(method: 'ReceiveChangeRequestInfo', handler: ChangeRequestInfoReceiveHandler): void;
    protected addHandler(method: 'ReceiveLandingPage', handler: LandingPageReceiveHandler): void;

    protected addHandler(method: string, handler: EventHandler): void {
        super.addHandler(method, handler);
    }

    addLandingPageReceiveHandler(handler: LandingPageReceiveHandler) {
        this.addHandler('ReceiveLandingPage', (landingPage) => {
            handler(landingPage);
        });
    }
    addCommentThreadOverviewReceiveHandler(handler: CommentThreadOverviewReceiveHandler) {
        this.addHandler('ReceiveCommentThreadsOverview', (commentThreadOverview) => {
            handler(commentThreadOverview);
        });
    }
    addChangeRequestInfoReceiveHandler(handler: ChangeRequestInfoReceiveHandler) {
        this.addHandler('ReceiveChangeRequestInfo', (changeRequests) => {
            handler(changeRequests);
        });
    }
}
